"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCube2 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconCube2 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.9997 2.26201C10.9997 1.88064 10.5899 1.63967 10.2566 1.82508L3.68565 5.48084C3.34298 5.67148 3.34313 6.16441 3.68592 6.35485L10.2569 10.0054C10.5901 10.1906 10.9997 9.94958 10.9997 9.56834V2.26201Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.74282 8.11882C2.40949 7.93363 1.99986 8.17476 2 8.55609L2.0027 15.678C2.00284 16.0591 2.41232 16.3 2.74552 16.1149L9.15383 12.5547C9.49673 12.3642 9.49673 11.871 9.15383 11.6805L2.74282 8.11882Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.89223 17.7657C3.54932 17.9562 3.54932 18.4494 3.89223 18.6399L10.2569 22.1758C10.5901 22.3609 10.9997 22.12 10.9997 21.7387V14.6669C10.9997 14.2857 10.5901 14.0447 10.2569 14.2298L3.89223 17.7657Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.9997 21.7387C12.9997 22.12 13.4092 22.3609 13.7425 22.1758L20.1071 18.6399C20.45 18.4494 20.45 17.9562 20.1071 17.7657L13.7425 14.2298C13.4092 14.0447 12.9997 14.2857 12.9997 14.6669V21.7387Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.2538 16.1149C21.587 16.3 21.9965 16.0591 21.9967 15.678L21.9994 8.55609C21.9995 8.17476 21.5899 7.93363 21.2565 8.11882L14.8455 11.6805C14.5026 11.871 14.5026 12.3642 14.8455 12.5547L21.2538 16.1149Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.3134 6.35484C20.6562 6.16441 20.6564 5.67148 20.3137 5.48084L13.7428 1.82508C13.4095 1.63967 12.9997 1.88064 12.9997 2.26201V9.56834C12.9997 9.94958 13.4092 10.1906 13.7425 10.0054L20.3134 6.35484Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 2.50002V12M12 12L20.5 7.27773M12 12L3.5 7.27773M12 12V21.5M20.5 16.7222L12.777 12.4317C12.4934 12.2741 12.3516 12.1954 12.2015 12.1645C12.0685 12.1371 11.9315 12.1371 11.7986 12.1645C11.6484 12.1954 11.5066 12.2741 11.223 12.4317L3.5 16.7222M21 16.0586V7.94147C21 7.59883 21 7.4275 20.9495 7.27471C20.9049 7.13953 20.8318 7.01545 20.7354 6.91076C20.6263 6.79242 20.4766 6.70922 20.177 6.54282L12.777 2.43171C12.4934 2.27415 12.3516 2.19537 12.2015 2.16448C12.0685 2.13715 11.9315 2.13715 11.7986 2.16448C11.6484 2.19537 11.5066 2.27415 11.223 2.43171L3.82297 6.54282C3.52345 6.70922 3.37369 6.79242 3.26463 6.91076C3.16816 7.01545 3.09515 7.13953 3.05048 7.27471C3 7.42751 3 7.59883 3 7.94147V16.0586C3 16.4012 3 16.5725 3.05048 16.7253C3.09515 16.8605 3.16816 16.9846 3.26463 17.0893C3.37369 17.2076 3.52345 17.2908 3.82297 17.4572L11.223 21.5683C11.5066 21.7259 11.6484 21.8047 11.7986 21.8356C11.9315 21.8629 12.0685 21.8629 12.2015 21.8356C12.3516 21.8047 12.4934 21.7259 12.777 21.5683L20.177 17.4572C20.4766 17.2908 20.6263 17.2076 20.7354 17.0893C20.8318 16.9846 20.9049 16.8605 20.9495 16.7253C21 16.5725 21 16.4012 21 16.0586Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconCube2 = IconCube2;
//# sourceMappingURL=IconCube2.js.map